/* global axios */
import ApiClient from '../ApiClient';

class CaptainConversationScripts extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ assistantId, page = 1, searchKey } = {}) {
    return axios.get(`${this.url}/${assistantId}/conversation_scripts`, {
      params: { page, searchKey },
    });
  }

  show({ assistantId, id }) {
    return axios.get(`${this.url}/${assistantId}/conversation_scripts/${id}`);
  }

  create({ assistantId, ...data } = {}) {
    return axios.post(`${this.url}/${assistantId}/conversation_scripts`, {
      conversation_script: data,
    });
  }

  update({ assistantId, id }, data = {}) {
    return axios.put(`${this.url}/${assistantId}/conversation_scripts/${id}`, {
      conversation_script: data,
    });
  }

  delete({ assistantId, id }) {
    return axios.delete(
      `${this.url}/${assistantId}/conversation_scripts/${id}`
    );
  }

  reorder({ assistantId, scriptIds }) {
    return axios.post(
      `${this.url}/${assistantId}/conversation_scripts/reorder`,
      { script_ids: scriptIds }
    );
  }
}

export default new CaptainConversationScripts();
